export enum ResendTicketsStages {
	Default,
	Loading,
	Success,
	Error
}
